import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Navbar from "../../../components/CustomNav/CustomNav.Component";
import BubbleChart from "../../../common/DataViz/bubbleChart.Component";
import "./searchFilters.css";
import { isUserLoggedIn, currentBaseUrl } from "../../../common/services";
import dummydata from "../../../assets/data/sampleTableData";
import withServices from '../../../HOCs/withServices';
import PieChart from '../../../common/DataViz/pie.Component';
import InstitutionsAPI from 'src/services/API/v1/Institutions';
import Loader from 'react-loader';


interface IProps {
  services?: any;
  history?: object;
}

class SearchFilters extends React.Component<IProps>{
  public state = {
    toLogin: false,
    loaded: false,
    filteredLoaded: true,
    datakey:  [            
      "User",            
      "AlertLevel",
      "viewmore"           
  ],
  tHead: [
      "Name",
      "Risk Group",
      "Action"
  ],
    assessments: new Array(),
    questionGroups: new Array(),
    selectedAssessment: Number,
    selectedGroup: 0,
    filteredStudents: new Array()
  };
  constructor(props) {
    super(props);
    this.resultsTableDisplay = this.resultsTableDisplay.bind(this);
    this.renderChart = this.renderChart.bind(this);
    this.assessmentPicker = this.assessmentPicker.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.searchFilterButtons = this.searchFilterButtons.bind(this);
    this.onSelectAssessment = this.onSelectAssessment.bind(this);
    this.onQuestionGroupClicked = this.onQuestionGroupClicked.bind(this);
    this.onPieSliceClicked = this.onPieSliceClicked.bind(this);
    this.viewMoreData = this.viewMoreData.bind(this);
    this.customTD = this.customTD.bind(this);
    this.fetchQuestionGroupData = this.fetchQuestionGroupData.bind(this);
  }

  public async componentDidMount() {
    const { services: { teachersAPI, adminAPI, isUserLoggedIn, currentUserID, fixturesAPI } } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }
 
    // const payload = await institutionsAPI.getInstitutionsAssessments(currentUserID);
    // const key = "assessments"
    // const assessments = payload.data[key];
    // const questionGrps = await adminAPI.getAssessmentQuestionGroups();

    const assessmentsRes = await teachersAPI.getInstitutionsAssessments();
    
    if (assessmentsRes.ok) {
      this.setState({ assessments: assessmentsRes.data.assessments, loaded: true});
    }
    
    
    // console.info("SearchFilters Payload1: " + JSON.stringify(questionGrps, null, 4));
  }
  public onLogout() {
    this.setState({ toLogin: true });
  }
  public customTD(props) {
    return (
      <td>
        {/*tslint:disable-next-line jsx-no-lambda*/}
        <button className="blue-button view-more-data"  onClick={() => this.viewMoreData(props)}>View More</button>
      </td>
    );
  }
  public viewMoreData(props) {
    // navigate to more student data
    // this.setState({navigate: true, destination: this.state.baseurl + "datacenter"});
    // this.setState({navigate: true, destination: this.state.baseurl + "viewstudentdata/" + props.rowData.id});
    const history: any = this.props.history;
    history.push(`${currentBaseUrl()}viewstudentdata/${props.rowData.id}`);
}

  public resultsTableDisplay() {
    // create table with student results
    const { filteredStudents } = this.state;
    if (filteredStudents.length) {
      return (
        <div className="filter-table-container">
          <SortableTbl
            tblData={filteredStudents}
            tHead={this.state.tHead}
            dKey={this.state.datakey}
            customTd={[
              { custd: this.customTD, keyItem: "viewmore", sortable: false }
            ]}
            defaultCSS={false}
          />
        </div>
      );
    } else {
      return <div />;
    }
  }

  public renderChart() {
    // nivo radar mapping results
    const { questionGroups, selectedGroup } = this.state;
    const pieData = [] as any;

     questionGroups.sort(function sortData(a, b) {
       return b.NumStudents - a.NumStudents;
     });

    questionGroups.forEach((group, i) => {
        // console.error( (group.NumStudents) + " || " + selectedGroup )
      pieData.push({
        id: String(group.id),
        label: group.Title,
        value: group.NumStudents,
        color:  this.assignColor(+selectedGroup, group.id)[0]
      })
    })
    return (
      <div className="radar-container">
        <PieChart realData={pieData} onSliceClick = {this.onPieSliceClicked} />
        {/* <RadarGraph /> */}
      </div>
    );
  }

  public assignClass (selected, qGrp) {
    console.log("class called type of: " + typeof selected + " || " + typeof qGrp)
    if (selected === qGrp) {      
      return "sf-button sf-button-active";
    }else {
      return "sf-button"
    }
  }
  public assignColor (selected, qGrp) {
    console.log("assign called type of: " + typeof selected + " || " + typeof qGrp)
     if (selected === qGrp) {
       return ["#acff24", "#00ebff"];
     } else {
       return ["#acff2480", "#3ee9f7"];
     }
  }

  public assessmentPicker() {
    const {assessments, loaded} = this.state;
    // query header
    if (this.state.assessments.length) {
      return (
        <div className="sf-query-wrapper">
          <div className="sf-query">
            <span>Please pick an assessment: </span>
            <span>
              <select className="custom-select sf-select" onChange={this.onSelectAssessment}>
                {/* filter options */}
                <option> -- </option>
                {assessments.map(assessment => <option key={assessment.id} value={assessment.id}>{assessment.name}</option>)}
              </select>
            </span>
            {/* <button className="blue-button go-button">GO</button> */}
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  }
public async onSelectAssessment(event) {
    // get assessment id & fetch question groups
    const { services: { currentUserID ,fixturesAPI, teachersAPI } } = this.props;

    this.setState({loaded: false}); 
    const selectedAssessment = event.target.value;
    const payloadRes = await teachersAPI.getAssessmentSearchFilters(selectedAssessment);
    
    console.log({payloadRes});

    if (payloadRes.ok) {
      const questionGroups =  payloadRes.data
      // get group total
      // let sum = 0;
      console.info(typeof questionGroups[0].NumStudents)
      const groupTotal = questionGroups.reduce((grp1, grpNext) => {
        return {NumStudents: grp1.NumStudents + grpNext.NumStudents }
      }); // reducer func to calculate total number of students in returned assessment
      const assessmentStudentTotal = groupTotal.NumStudents;
      this.setState({questionGroups, selectedAssessment, filteredStudents: [], assessmentStudentTotal, loaded: true});
    }
    
  }

public async onQuestionGroupClicked(event) {
  // set questiongroupid
  const selectedGroup = event.target.value;
  this.fetchQuestionGroupData(selectedGroup)
  
}
public async fetchQuestionGroupData(selectedGroup) {
  this.setState( {selectedGroup, filteredStudents: [], loaded: false}); // use to change button styles
  const { selectedAssessment } = this.state;
  // const selectedGroupTemp = 1; // idealy should be made dynamic 
  const { services: {currentUserID, fixturesAPI, teachersAPI}} = this.props;  
  
  const payloadRes = await teachersAPI.getSearchFiltersStudents(selectedAssessment, selectedGroup);
  
  console.log({payloadRes});

  if (payloadRes.ok) {
    const filteredStudents = payloadRes.data.results;
    this.setState({ filteredStudents, loaded: true})  
  }
  
}

public onPieSliceClicked = (grpId: string) => (event: React.MouseEvent) => {
  this.fetchQuestionGroupData(grpId);
}
  public searchFilterButtons() {
    const { questionGroups, selectedAssessment, selectedGroup } = this.state;
    // const groups = questionGroups.questiongroups
      if(questionGroups){
        return (
          <div className="sf-buttons-wrapper">
            {/* ideally mapped from fetched data */}
            {questionGroups.map(questiongrp => (
              <button
                onClick={this.onQuestionGroupClicked}
                className={this.assignClass(+selectedGroup, questiongrp.id) }
                key={questiongrp.id}
                value={questiongrp.id}
              >
                {questiongrp.Title}
              </button>
            ))}
          </div>
        );
    
    } else {
      return <div/>;
    }
  }

  
  public render() {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    return (
      // <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
      <div className="sf-page">
        <Navbar logoutParent={this.onLogout} />
        <div className="sf-container">
          <div className="sf-content">
            <h1 className="sf-page-heading">SEARCH &amp; FILTER RESULTS</h1>
        <div className="sf-page-row">            
          {this.assessmentPicker()}
        </div>
            <div className="sf-page-row">
              {this.searchFilterButtons()}
            </div>
            <div className="sf-page-row">
              {this.renderChart()}
            </div>
            {this.resultsTableDisplay()}
            <Loader color="#acff24" loaded={this.state.loaded}/>
          </div>
        </div>
      </div>
      // </CSSTransition>
    );
  }
}
export default withServices(SearchFilters);


// WEBPACK FOOTER //
// ./src/pages/DataCenter/SearchFilters/teacherSearchFilters.Component.tsx